import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

export interface CardActionProps {
  to?: string;
  actionLabel?: string;
}

const buttonSx = {
  mt: 3,
  borderRadius: 999,
  py: 1.15,
  fontWeight: 700,
  textTransform: 'none',
  fontSize: 16,
  lineHeight: 1,
};

const CardAction = ({ to, actionLabel = 'Open App' }: CardActionProps) => {
  const navigate = useNavigate();

  return (
    <Button
      variant="contained"
      disableElevation
      sx={buttonSx}
      onClick={() => {
        if (to) void navigate(to);
      }}
    >
      {actionLabel}
    </Button>
  );
};

export default CardAction;
